import { render, staticRenderFns } from "./cardsRight.vue?vue&type=template&id=161d0dce&"
import script from "./cardsRight.vue?vue&type=script&lang=js&"
export * from "./cardsRight.vue?vue&type=script&lang=js&"
import style0 from "./cardsRight.vue?vue&type=style&index=0&id=161d0dce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports